import { convertLocaltoUTCFormat } from "../services/DateFormatUtility";

export const EUETS_VOYAGES_COLUMNS = [
	{
		accessorKey: "PortOfDeparture",
		header: "Port of Departure",
		size: 200,
	},
	{
		accessorKey: "PortOfArrival",
		header: "Port of Arrival",
	},
	{
		accessorKey: "DateTimeOfDeparture",
		header: "Date and Time of Departure(UTC)",
		accessorFn: (row) => {
			if (row.DateTimeOfDeparture) {
				return convertLocaltoUTCFormat(row.DateTimeOfDeparture);
			}
		},
	},
	{
		accessorKey: "DateTimeOfArrival",
		header: "Date and Time of Arrival(UTC)",

		accessorFn: (row) => {
			if (row.DateTimeOfArrival) {
				return convertLocaltoUTCFormat(row.DateTimeOfArrival);
			}
		},
	},
	{
		accessorKey: "PortalVerificationStatus",
		header: "Portal Initial Verification Status",
	},
	{
		accessorKey: "Co2mrv",
		header: "CO2 mrv",
		size: 120,
	},
	{
		accessorKey: "Ch4mrv",
		header: "CH4 mrv",
		size: 120,
	},
	{
		accessorKey: "N2omrv",
		header: "N2O mrv",
		size: 120,
	},
	{
		accessorKey: "ReductionFactor",
		header: "Reduction factor",
	},
	{
		accessorKey: "CarbonCaptureAndStorage",
		header: "Carbon Capture & Storage",
	},
	{
		accessorKey: "Ghgmrv",
		header: "GHG mrv",
	},
	{
		accessorKey: "selectVoyagesEntryForStatementDownload",
		header: "SELECT VOYAGES ENTRY FOR STATEMENT DOWNLOAD",
		size: 200,
	},
];

export const CARBON_INTESITY_INDICATOR_COLUMNS = [
	{
		accessorKey: "timeStamp",
		header: "Time Stamp",
		size: 100,
		accessorFn: (row) => {
			if (row.timeStamp) {
				return convertLocaltoUTCFormat(row.timeStamp);
			}
		},
	},
	{
		accessorKey: "eventType",
		header: "Event Type",
	},
	{
		accessorKey: "portCode",
		header: "Port",
		size: 100,
	},
	{
		accessorKey: "portalVerificationStatus",
		header: "Portal Initial Verification Status",
	},
	{
		accessorKey: "aeR_Without_Exclusion",
		header: "EST AER W/O Exclusion",
	},
	{
		accessorKey: "aeR_With_Exclusion",
		header: "EST AER With Exclusion",
	},
];
